// extracted by mini-css-extract-plugin
export default {"previewTable":"ReportConsolidadoEmpresasPreview_previewTable__mXbzq"};